export default __webpack_public_path__ + "static/b2-b4d623274df51a9b6f5010a23fb88f82.png";